import React from 'react';
import AdminLayout from './components/adminlayout';
import BillingEdit from './components/billingedit';

const Billing = () => (
    <AdminLayout>
        <div className='p-6'>
            <div className='bg-white rounded-lg border border-gray-200 p-6'>
                <BillingEdit />
            </div>
        </div>
    </AdminLayout>
);
export default Billing;
